import { Form } from 'factorial-form'

export default class IdentifiersForm extends Form {
  constructor(values: object) {
    super(values, {
      social_security_number: 'string',
      tax_id: 'string',
      country: 'string',
      employee_id: 'string',
    })
  }
}
